var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"tit"}),_c('div',{staticClass:"btn",on:{"click":_vm.goNext}},[_vm._v("进 入")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }